import * as React from 'react'

function SvgMobilePhoneIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.84.75H2.387c-.94 0-1.704.84-1.704 1.875v12.75c0 1.035.763 1.875 1.704 1.875h5.455c.94 0 1.704-.84 1.704-1.875V2.625C9.545 1.59 8.782.75 7.841.75zM5.114 16.5c-.565 0-1.022-.502-1.022-1.125s.457-1.125 1.022-1.125c.566 0 1.023.502 1.023 1.125S5.68 16.5 5.113 16.5zm3.069-3H2.045V3h6.137v10.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgMobilePhoneIcon
